import {useCreateMediaPlanMutation, useGetMediaPlanQuery} from "../../../redux/survey/media-plan.endpoints";
import {SurveyMediaPlanStatus} from "../../../redux/survey/media-plan.types";
import {useEffect, useState} from "react";
import {SurveyStatus} from "../../../redux/survey/survey.types";

const SURVEY_MEDIA_PLAN_REFRESH_INTERVAL = 5000;
export const useSurveyMediaPlan = (extSurveyId: string, surveyStatus?: SurveyStatus, isShare?: boolean) => {
  const [isGeneratingMediaPlan, setIsGeneratingMediaPlan] = useState(false);
  const [pollingInterval, setPollingInterval] = useState<number | undefined>(undefined);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [planData, setPlanData] = useState<any>(null);

  const { data, error: planError, isLoading: isGetLoading, refetch } = useGetMediaPlanQuery(
    {ext_survey_id: extSurveyId, share: isShare},
    { pollingInterval }
  );

  const [createCall, { isLoading: isCreationLoading, isSuccess: createSuccess }] = useCreateMediaPlanMutation(
    { fixedCacheKey: `media-plan-${extSurveyId}` }
  );

  const isLoadingPlan = isCreationLoading || isGetLoading;
  const mediaPlanAvailable = planData && planData?.rawMediaPlan && planData.mediaPlanStatus == SurveyMediaPlanStatus.Completed;

  useEffect(() => {
    if (createSuccess) {
      setIsGeneratingMediaPlan(true);
      setPlanData(null);
      refetch();
    }
  }, [createSuccess, refetch]);

  useEffect(() => {
    if (data) {
      setPlanData(data);
    }
  }, [data]);

  useEffect(() => {
    if (planError) {
      setIsGeneratingMediaPlan(false);
      return;
    }

    if (mediaPlanAvailable) {
      setIsGeneratingMediaPlan(false);
      setPollingInterval(undefined);
    } else if (isGeneratingMediaPlan) {
      setPollingInterval(SURVEY_MEDIA_PLAN_REFRESH_INTERVAL);
    }
  }, [planError, mediaPlanAvailable, isGeneratingMediaPlan]);

  const initiateMediaPlanCreation = () => {
    setIsGeneratingMediaPlan(true);
    setPlanData(null);
    void createCall({ ext_survey_id: extSurveyId });
  };

  return {
    canCreatePlan: !isShare && !isGeneratingMediaPlan && !isLoadingPlan,
    createMediaPlan: initiateMediaPlanCreation,
    isLoadingPlan,
    mediaPlan: planData?.rawMediaPlan,
    isGeneratingMediaPlan,
  };
};
